<script setup lang="ts">
import { RouteName } from "@/router";
import { authService } from "@/services/auth-service";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import {
  isCustomerAdminForAtLeastOneCustomer,
  isOneAdmin,
  isOneUser,
  isOneUserAdmin,
} from "@/utils/roles.util";

const router = useRouter();

onBeforeMount(async () => {
  const authenticatedUser = authService.loggedInUser;

  if (authenticatedUser) {
    const loggedInUser = await authService.loadLoggedInUser();
    if (loggedInUser) {
      if (loggedInUser) {
        if (isOneAdmin(loggedInUser)) {
          await router.push({ name: RouteName.Customers });
          return;
        } else if (isCustomerAdminForAtLeastOneCustomer(loggedInUser)) {
          await router.push({ name: RouteName.Customers });
          return;
        } else if (isOneUser(loggedInUser) || isOneUserAdmin(loggedInUser)) {
          await router.push({ name: RouteName.PhoneService });
          return;
        } else {
          await router.push({ name: RouteName.ServiceOrders });
          return;
        }
      }
    }
  } else {
    await router.push({ name: RouteName.Login });
  }
});
</script>

<template>
  <section class="section">
    <app-loader></app-loader>
  </section>
</template>
